
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'



import wx from 'weixin-js-sdk'

export default {
name: 'workorder',
directives: {
TransferDom
},
components: {
cmBlank,cmLoadmore,wx,Popup,Group,PopupHeader,Radio,
},
data () {
return {
title:'工单列表',
status:0,
keyword:'',
blankShow:false,
loadStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
category:[],
labels:[],
searchPop:false,
community:'',
cateId:0,
labelsId:0,
labelTitle:'',
services:[],
itemId:0,
serviceId:0,
pickerStatus:false,
orders:[
{
key:'id',
title:'发起时间',
},
{
key:'deadline',
title:'处理截止时间',
},
],
orderItem:0,
orderType:0,


}
},
created(){
this.status = Number(this.$route.params.i);
},
beforeRouteLeave(to, from, next) {
if(to.name == 'workOrderInfo'){
from.meta.keepAlive = true;
}else{
var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '') : this.$vnode.key
var cache = this.$vnode.parent.componentInstance.cache
var keys = this.$vnode.parent.componentInstance.keys
console.log(key,cache,keys);
if (cache[key]) {
if (keys.length) {
var index = keys.indexOf(key)
if (index > -1) {
keys.splice(index, 1)
}
}
delete cache[key]
}
}
next();
},
mounted(){
this.getCategory();
this.getService();
this.getLabels();
},
methods:{
copy(val){
this.$func.copy(val,event);
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
sort(i){
this.orderItem = i;
this.search();
},
order(i){
this.orderType = i;
this.search();
},
getList(){
let params = {
last_id:this.lastId,page_flag:this.pageFlag,status:this.status,
keyword:this.keyword,cate_id:this.cateId,community:this.community,
label:this.labelTitle,orderItem:this.orders[this.orderItem].key,orderType:this.orderType
};
this.$api.workOrder(params).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
getCategory() {
this.$api.workCategory({status:this.status,type:1}).then((res)=>{
if(res){
this.category = res.data;
}
})
},
getLabels() {
this.$api.workLabels({status:this.status}).then((res)=>{
if(res){
this.labels = res.data;
}
})
},
detail(id){
this.$router.push({name:'workOrderInfo',params:{id:id}})
},
cate(id){
this.cateId = id;
},
label(id,title){
this.labelsId = id;
this.labelTitle = title;
},
showPic(pics,index) {
wx.previewImage({
current: pics[index], // 当前显示图片的http链接
urls: pics 
});
},
resetSearch(){
this.community = '';
this.cateId = 0;
this.labelTitle = '';
this.keyword = '';
this.orderItem = 0;
this.orderType = 0;
},
searchSubmit(){
this.lastId = 0;
this.pageFlag = 2;
this.list = [];
this.loadmore();
this.searchPop = false;
},
getService(){
this.$api.getService({}).then((res)=>{
if(res){
this.services = res.data;
}
})
},
assignService(id){
this.itrmId = id;
this.pickerStatus = true;
},
onSercice (value) {
this.serviceId = value;
},
confirmService () {
let that = this;
if(!this.serviceId){
this.$func.showToast('请选择客服');
return false;
}
this.$func.confirm('确认操作？','提示',()=>{
this.$api.assignService({id:this.itrmId,serviceId:this.serviceId}).then((res)=>{
if(res){
that.pickerStatus = false;
that.search();
}
})
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';

this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/workorder.vue